import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
} from "@mui/material";

export type SelectFieldProps = {
  property: string;
  value: string;
  type: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  items: string[];
};

export const SelectField = ({ property, value, onChange, type, items }: SelectFieldProps) => {
  return (
    <FormControl sx={{ position: "relative" }}>
      <InputLabel>{property}</InputLabel>
      <Select value={value || ""} onChange={onChange} input={<OutlinedInput label={property} />}>
        {items.map((item) => (
          <MenuItem key={item} value={item}>
            {item}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText>{type}</FormHelperText>
    </FormControl>
  );
};
